import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BoardStages } from 'app/trello/models/board-stages';
import { RequestErrorThrower } from 'app/trello/services/request-error-thrower';
import { TokenService } from 'app/trello/services/token.service';
import { environment } from 'environments/environment';
import { catchError, Observable, switchMap, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BoardStagesFetcher {

  constructor(
    private readonly http: HttpClient,
    private readonly requestErrorThrower: RequestErrorThrower,
    private readonly tokenService: TokenService,
  ) {
  }

  public fetch(): Observable<BoardStages> {

    const url = `${environment.apiRoot}${environment.endpoints.boardStages}`;

    return this.tokenService.userToken
      .pipe(
        take(1),
        switchMap((userToken) =>

          this.http.get<BoardStages>(
            url,
            {headers: {Authorization: `Bearer ${userToken}`}},
          ),
        ),
        catchError((error: any) => {

          console.error('An error occurred fetching board stages:', error);

          return this.requestErrorThrower.throwError(error);
        }),
      );
  }

}
